import { Component, Input, OnInit } from '@angular/core';
import { StaticPagesService } from '../../shared/services/static-page/static-pages.service';
import { PageType } from '../../shared/models/enums/pageType';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImgViewComponent } from '../../shared/components/img-view/img-view.component';
import { Router, RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ImgViewComponent,
    RouterModule,
  ],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss',
})
export class BlogComponent implements OnInit {
  @Input() count: number = 0;

  blogs: any;

  constructor(
    private staticPagesService: StaticPagesService,
    private titleService: Title,
    private metaService: Meta,
    public router: Router
  ) {}  
  async ngOnInit(): Promise<void> {
      this.staticPagesService.getByPageType(PageType.Blog, this.router.url === '/').subscribe((data) => {
        if (this.count > 0) this.blogs = data.slice(0, this.count);
        else this.blogs = data;
      });

      if (this.count == 0) {
        this.titleService.setTitle('VizeAsist | Blog - Makale - Kampanya');
        this.metaService.updateTag({
          property: 'og:title',
          content: 'VizeAsist | Blog - Makale - Kampanya',
        });
        this.metaService.updateTag({ name: 'description', content: '' });
        this.metaService.updateTag({ property: 'og:description', content: '' });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'blog, yardım, destek',
        });
      }
    }
  }
